import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { leaveEmergencyMode, EmergencyModeLeft } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useTerminateEmergencyMode = (
  options: UseMutationOptions<EmergencyModeLeft, unknown, void, unknown> = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => extractData(leaveEmergencyMode()),
    ...options,
    onSuccess(...args) {
      queryClient.resetQueries({ queryKey: ['emergencyMode', 'current'] });
      options.onSuccess?.(...args);
    },
  });
};
